import { forBrand, environment, envName } from "../lib/base.js";
import { Configurable } from "../lib/configurable.js";
import "deepmerge";
const globalConfig = Configurable.props({
  brand: forBrand({
    adidas: "adidas",
    reebok: "reebok"
  }),
  domain: forBrand({
    adidas: "adidas",
    reebok: "reebok"
  }),
  env: environment({
    local: "local",
    development: "dev",
    staging: "stg",
    production: "prod"
  }),
  envName
});
export {
  globalConfig
};
//# sourceMappingURL=global-config.js.map
